// Websockets
export const WSG_BASE_URL = process.env.REACT_APP_WSG || 'wss://wsg.devstage.cloud';
export const WSG_POLLING_INTERVAL_SECONDS = 5; // refetch all messages each 10 seconds (offline mode)

export const WS_MAX_RETRY_COUNT = 3;
export const WS_RETRY_INTERVAL = 5 * 1000; // 3ms
export const WS_PING_PONG_INTERVAL = 30 * 1000; // 30 seconds
const WS_MAX_PING_COUNT = 3;
export const WS_HEALTH_CHECK_INTERVAL = WS_PING_PONG_INTERVAL * WS_MAX_PING_COUNT;
